export default __webpack_public_path__ + "static/media/ic_delete.30411443.svg";